/* eslint-disable max-len */
import 'react';

const ArrowRightStyleOptimizeSvg =
  (): React.PropsWithoutRef<React.ReactSVGElement> => (
      <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M6.034 4.007a.498.498 0 01-.145.311L3.061 7.146a.5.5 0 11-.707-.707l2.5-2.5-2.5-2.5A.5.5 0 113.06.732l2.828 2.829a.498.498 0 01.145.31z"
              fill="#242933"
              fillRule="evenodd"
          />
      </svg>
  );
export default ArrowRightStyleOptimizeSvg;
